import { useCurrencyStore } from '../stores/useCurrencyStore'

export const formatPriceWithCurrency = (price: number, fromCurrency: 'NGN' | 'USD' = 'NGN'): string => {
  const { currency, convertPrice } = useCurrencyStore.getState()
  const convertedPrice = convertPrice(price, fromCurrency)
  
  if (currency === 'USD') {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
    }).format(convertedPrice)
  } else {
    return new Intl.NumberFormat('en-NG', {
      style: 'currency',
      currency: 'NGN',
    }).format(convertedPrice)
  }
}

export const useCurrencyFormatter = () => {
  const { currency, convertPrice } = useCurrencyStore()
  
  return {
    formatPrice: (price: number, fromCurrency: 'NGN' | 'USD' = 'NGN') => {
      const convertedPrice = convertPrice(price, fromCurrency)
      
      if (currency === 'USD') {
        return new Intl.NumberFormat('en-US', {
          style: 'currency',
          currency: 'USD',
        }).format(convertedPrice)
      } else {
        return new Intl.NumberFormat('en-NG', {
          style: 'currency',
          currency: 'NGN',
        }).format(convertedPrice)
      }
    },
    currency,
    convertPrice
  }
}